<template>
  <div>
    <div class="content-box">
      <h1 class="content-title">元气资讯</h1>
      <ul class="news-list clearfix">
        <li v-for="(item, index) in newsList" :key="new Date() + index" class="fl clearfix">
          <p class="name">{{item.title}}</p>
          <div class="info ellipsis2">
            {{item.info}}
          </div>
          <p class="money fr" @click="state = false">
            付费阅读{{item.money}}元
          </p>
        </li>
      </ul>
    </div>
    <div class="pay-dialog" :class="{hide: state}" @click.self="state = true">
      <div class="pay-content">
        <!-- <vue-qr class="qr" :text="downloadData.url" logoBackgroundColor="#fff" :margin="0" colorLight="#fff" :logoSrc="downloadData.icon" :logoScale="0.2" :size="downloadData.size"></vue-qr> -->
      </div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import home from './home'
export default {
  components: {
    VueQr,
    home
  },
  name: 'news',
  data () {
    return {
      state: true,
      newsList: [
        {
          title: '新品首发',
          info: '0糖0脂0卡糖，SOLO出道！元气研究所0卡糖',
          money: 9.9
        },
        {
          title: '焕新首发',
          info: '一样地浓，不一样的「濃」',
          money: 9.9
        },
        {
          title: '冬季限定',
          info: '气泡家族再添新品！这一次是甘王草莓味的~',
          money: 9.9
        },
        {
          title: '你也是喜欢喝酒的女生吗？',
          info: '微醺少女酒上新',
          money: 9.9
        },
        {
          title: '新品首发',
          info: '添加夏黑葡萄原汁，1.3倍气泡，元气森林气泡家族迎来新成员！',
          money: 9.9
        },
        {
          title: '元气食堂',
          info: '没想到，水果跟三明治这么配！',
          money: 9.9
        },
        {
          title: '元气食堂',
          info: '元气森林气泡水の灵感下午茶',
          money: 9.9
        },
        {
          title: '元气食堂',
          info: '到底有没有吃了可以减肥的全麦面包？',
          money: 9.9
        },
        {
          title: '元气食堂',
          info: '糖很可怕吗？',
          money: 9.9
        },
        {
          title: '元气食堂',
          info: '选错了酱料吃草也长胖！好吃不胖的酱料来了~',
          money: 9.9
        }
      ],
      downloadData: {
        url: 'https://mall-static.yqslmall.com//release/material/b9ef32672f6045a1885909cca387f226.png',	// 跳转路径 or 图片
        icon: require('../../static/images/qr.png'),	// logo
        size: 200	// logo大小
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
* {
  list-style: none;
  margin: 0;
  padding: 0;
}
.content-box {
  width: 940px;
  margin: 0 auto;
  background: #fdf2ed;
  .content-title {
    color: #ff6419;
    font-size: 48px;
    margin-top: 40px;
    font-weight: 400;
  }
  .news-list {
    width: 100%;
    margin-top: 20px;
    li:nth-child(even) {
      margin-left: 20px;
    }
    li {
      width: 460px;
      height: 259px;
      background: #ffffff;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
      border-radius: 24px;
      padding: 32px 24px 28px 24px;
      box-sizing: border-box;
      margin-top: 20px;
      .name {
        color: #ff6419;
        font-size: 20px;
      }
      .info {
        color: #333;
        font-size: 24px;
        margin-top: 8px;
        height: 100px;
      }
      .money {
        width: 192px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: #ff6419;
        border-radius: 27px;
        color: #fff;
        margin-top: 15px;
        cursor: pointer;
      }
    }
  }
}
.pay-dialog {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  transition: all 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  .pay-content {
    width: 460px;
    height: 710px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 24px;
    background: url("/static/images/pay.png") no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    .qr {
      margin-top: 100px;
    }
  }
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}
.ellipsis2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.hide {
  opacity: 0;
  visibility: hidden;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/views/news.vue